import React, { useState, useEffect } from "react";
import axios from "axios";
import { ShoppingCart } from "react-feather";
import { baseurl } from "../Baseurl";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

const Addtocartcomp = ({ type, listing_id }) => {
  const cust_id = localStorage.getItem("cust_id");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success", "warning", or "error"
  const [isItemInCart, setIsItemInCart] = useState(false); // Track if item exists in cart

  // 🔄 Use context for cart
  const { fetchCartDetails, cartCount, cartItems } = useCart();

  // Check if item is already in cart
  useEffect(() => {
    if (cust_id && cartItems.length > 0) {
      const itemExists = cartItems.some(
        (item) => item.listing_id === listing_id && item.type === type
      );
      setIsItemInCart(itemExists);
    }
  }, [cartItems, listing_id, type, cust_id]);

  // Function to Add Item to Cart
  const handleAddToCart = async () => {
    if (!cust_id || isItemInCart) return;

    try {
      const requestData = { listing_id, type, cust_id };
      console.log("Sending data to AddToCart API:", requestData);

      const response = await axios.post(`${baseurl}AddToCart`, requestData);
      console.log("Response from server:", response.data);

      if (response.data.alreadyExists) {
        setMessage("🛒 Item is already in your cart! OR Quotation Sent Successfully");
        setMessageType("warning");
      } else {
        setMessage("✅ " + response.data.message);
        setMessageType("success");
        fetchCartDetails(); // refresh global cart state
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
      setMessage("❌ Something went wrong!");
      setMessageType("error");
    }
  };

  // Auto-hide message after 3 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div>
      {cust_id ? (
        <button
          className="add-to-cart-btn mt-3"
          onClick={handleAddToCart}
          disabled={isItemInCart}
        >
          <ShoppingCart size={19} />
          &nbsp;
          {isItemInCart
            ? type === "quoteRequest"
              ? "Quotation request sent Successfully"
              : "Item Added to Cart"
            : type === "quoteRequest"
            ? "Request A Quotation"
            : "Add to Cart"}
        </button>
      ) : (
        <Link to="/customer/login" className="add-to-cart-btn mt-3 text-white">
          Login to Buy This Item
        </Link>
      )}

      {/* Message Toast */}
      {message && (
        <div className={`custom-toast ${messageType}`}>{message}</div>
      )}

      {/* Cart Count Icon */}
      {cust_id && cartCount > 0 && (
        <div className="cart-container">
          <Link to="/cart" className="cart-icon">
            <ShoppingCart size={24} />
            <span className="cart-count">{cartCount}</span>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Addtocartcomp;
